module.exports = __webpack_public_path__ + "img/meter-minus.f4c47350.svg";